import wow from 'wow.js';

// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    // Init WOW.js
    new wow().init();

});